var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.344 20.266a1.031 1.031 0 1 0 0 2.062 1.031 1.031 0 0 0 0-2.062Zm-7.125 0a1.031 1.031 0 1 0 0 2.062 1.031 1.031 0 0 0 0-2.062Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.686 2.328a.774.774 0 0 0 0 1.547h1.658l.588 3.36v.003l1.43 8.074H6.36l.593 3.47a1.29 1.29 0 0 0 1.27 1.072h9.697a.774.774 0 0 0 0-1.547H8.442l-.403-2.352h9.858a1.73 1.73 0 0 0 1.362-.642c.652-.822 1.394-2.033 1.953-3.392.558-1.354.959-2.916.861-4.423l-.015-.13c-.105-.628-.663-1.038-1.25-1.039H6.344l-.513-2.934a1.29 1.29 0 0 0-1.27-1.067H2.686Zm17.852 5.548c.016 1.112-.288 2.32-.756 3.456-.505 1.226-1.174 2.311-1.736 3.019-.02.025-.067.057-.15.057H7.772L6.616 7.876h13.922Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/purchase.3e4b4adface67abdeef104443725d1db.svg";
export { ForwardRef as ReactComponent };